module.exports = __webpack_public_path__ + "img/203.broken_hand_paper_dispenser_Hand_dryer.1b508685.svg";